import { render } from "./Sidebar.vue?vue&type=template&id=1373b960&scoped=true"
import script from "./Sidebar.vue?vue&type=script&lang=ts"
export * from "./Sidebar.vue?vue&type=script&lang=ts"

import "./Sidebar.vue?vue&type=style&index=0&id=1373b960&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-1373b960"

export default script